export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: 3,
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 3,
  },
  loader: {
    color: '#451b0c',
  },
  successIcon: {
    fontSize: 100,
    color: '#4caf50',
  },
  errorIcon: {
    fontSize: 100,
    color: '#f44336',
  },
  warningIcon: {
    fontSize: 100,
    color: '#ff9800',
  },
  title: {
    fontWeight: 600,
    color: '#333',
  },
  description: {
    color: '#666',
    maxWidth: 500,
  },
  button: {
    marginTop: 2,
    paddingX: 4,
    paddingY: 1.5,
  },
  buttonGroup: {
    display: 'flex',
    gap: 2,
    marginTop: 2,
  },
};
